import { z } from 'zod';
import { EVENT_PREFERENCES, EventKeySchema } from './schema-generators';

const PreferencesSchema = z.object({
  userId: z.string(),
  preferenceType: z.string().optional(),
  ...EVENT_PREFERENCES,
});

export type Preferences = z.infer<typeof PreferencesSchema>;

export const NotificationPreferencesResponseSchema = PreferencesSchema.extend({
  availableEvents: z.array(EventKeySchema),
  accountId: z.number().optional(),
  payloadTimestamp: z.string().optional(),
  is_deleted: z.number().optional(),
}).passthrough(); // Preserve unknown fields for future compatibility

export type NotificationPreferencesResponse = z.infer<typeof NotificationPreferencesResponseSchema>;
